import * as LocalStorage from './localStorageHelper'

const productsCacheMaxAge = 30 * 60 * 1000 // 30min
const storeKey = 'Products_Store';

const RECOMMEND = {
  "85025100400": {
    "_id": "592484259447efa4c3a85e18",
    "Item Lookup Code": "85025100400",
    "Department": "SNACKS",
    "Description": "SKINNY POP ORIGINAL ",
    "Ext'd Description": "",
    "Size": "LARGE BAG",
    "Sub Description 2": "POPCORN",
    "Sub Description 3": "",
    "PriceB": "4.29",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/85025100400.jpg",
    "Qty": 'NA'
  },
  "09838260899": {
    "_id": "5924841b9447efa4c3a8537a",
    "Item Lookup Code": "09838260899",
    "Department": "MIXERS & SUPPLIES",
    "Description": "PLASTIC WINE GLASS",
    "Ext'd Description": "",
    "Size": "10ct",
    "Sub Description 2": "BAR SUPPLIES",
    "Sub Description 3": "",
    "PriceB": "4.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/09838260899.jpg",
    "Qty": 'NA'
  },
  "05025592100": {
    "_id": "592484229447efa4c3a85b39",
    "Item Lookup Code": "05025592100",
    "Department": "SNACKS",
    "Description": "RITTER SPORT DRK CHOC 73%",
    "Ext'd Description": "",
    "Size": "3.5oz",
    "Sub Description 2": "PREMIUM",
    "Sub Description 3": "DARK CHOCOLATE",
    "PriceB": "3.29",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/05025592100.jpg",
    "Qty": 'NA'
  },
  "02502409": {
    "_id": "5924841c9447efa4c3a855b5",
    "Item Lookup Code": "02502409",
    "Department": "MIXERS & SUPPLIES",
    "Description": "SIMPLY ORANGE ",
    "Ext'd Description": "",
    "Size": "11oz ",
    "Sub Description 2": "JUICE",
    "Sub Description 3": "",
    "PriceB": "2.2",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/02502409.jpg",
    "Qty": 'NA'
  },
  "04116541229": {
    "_id": "5924841b9447efa4c3a853af",
    "Item Lookup Code": "04116541229",
    "Department": "MIXERS & SUPPLIES",
    "Description": "SOLO CUPS ",
    "Ext'd Description": "",
    "Size": "20ct",
    "Sub Description 2": "BAR SUPPLIES",
    "Sub Description 3": "",
    "PriceB": "3.79",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/04116541229.jpg",
    "Qty": 'NA'
  },
  "02840002796": {
    "_id": "592484219447efa4c3a85a33",
    "Item Lookup Code": "02840002796",
    "Department": "SNACKS",
    "Description": "LAYS CLASSIC ",
    "Ext'd Description": "",
    "Size": "SMALL BAG",
    "Sub Description 2": "CHIPS",
    "Sub Description 3": "LAYS",
    "PriceB": "1.69",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/02840002796.jpg",
    "Qty": 'NA'
  },
  "350": {
    "_id": "5924841b9447efa4c3a853cc",
    "Item Lookup Code": "350",
    "Department": "MIXERS & SUPPLIES",
    "Description": "ICE",
    "Ext'd Description": "",
    "Size": "7lbs ",
    "Sub Description 2": "BAR SUPPLIES",
    "Sub Description 3": "",
    "PriceB": "3.5",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/350.jpg",
    "Qty": 'NA'
  },
  "04900005010": {
    "_id": "5924841d9447efa4c3a85676",
    "Item Lookup Code": "04900005010",
    "Department": "MIXERS & SUPPLIES",
    "Description": "COKE",
    "Ext'd Description": "",
    "Size": "2L",
    "Sub Description 2": "SODA",
    "Sub Description 3": "REGULAR",
    "PriceB": "2.49",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/04900005010.jpg",
    "Qty": 'NA'
  },
  "07800015245": {
    "_id": "5924841b9447efa4c3a853ed",
    "Item Lookup Code": "07800015245",
    "Department": "MIXERS & SUPPLIES",
    "Description": "CANADA DRY GINGER ALE",
    "Ext'd Description": "",
    "Size": "1L",
    "Sub Description 2": "MIXERS",
    "Sub Description 3": "",
    "PriceB": "2.29",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/07800015245.jpg",
    "Qty": 'NA'
  },
  "07800014645": {
    "_id": "5924841b9447efa4c3a853a6",
    "Item Lookup Code": "07800014645",
    "Department": "MIXERS & SUPPLIES",
    "Description": "CANADA DRY CLUB SODA ",
    "Ext'd Description": "",
    "Size": "1L",
    "Sub Description 2": "MIXERS",
    "Sub Description 3": "",
    "PriceB": "2.29",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/07800014645.jpg",
    "Qty": 'NA'
  },
  "04175500106": {
    "_id": "5924841c9447efa4c3a8553a",
    "Item Lookup Code": "04175500106",
    "Department": "MIXERS & SUPPLIES",
    "Description": "LANGERS APPLE JUICE ",
    "Ext'd Description": "",
    "Size": "64oz",
    "Sub Description 2": "JUICE",
    "Sub Description 3": "",
    "PriceB": "4.89",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/04175500106.jpg",
    "Qty": 'NA'
  },
  "9311493000509": {
    "_id": "5924841b9447efa4c3a85421",
    "Item Lookup Code": "9311493000509",
    "Department": "MIXERS & SUPPLIES",
    "Description": "BUNDABERG GINGER BEER",
    "Ext'd Description": "",
    "Size": "4 PACK",
    "Sub Description 2": "MIXERS",
    "Sub Description 3": "",
    "PriceB": "6.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/9311493000509.jpg",
    "Qty": 'NA'
  },
  "61126910802": {
    "_id": "5924841d9447efa4c3a855bd",
    "Item Lookup Code": "61126910802",
    "Department": "MIXERS & SUPPLIES",
    "Description": "RED BULL",
    "Ext'd Description": "",
    "Size": "4 PACK",
    "Sub Description 2": "ENERGY DRINK",
    "Sub Description 3": "RED BULL",
    "PriceB": "7.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/61126910802.jpg",
    "Qty": 'NA'
  },
  "01480058200": {
    "_id": "5924841b9447efa4c3a853c4",
    "Item Lookup Code": "01480058200",
    "Department": "MIXERS & SUPPLIES",
    "Description": "REAL LIME ",
    "Ext'd Description": "",
    "Size": "2.5oz",
    "Sub Description 2": "COCKTAIL MIXERS",
    "Sub Description 3": "",
    "PriceB": "0.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/01480058200.jpg",
    "Qty": 'NA'
  },
  "04900005011": {
    "_id": "5924841d9447efa4c3a85671",
    "Item Lookup Code": "04900005011",
    "Department": "MIXERS & SUPPLIES",
    "Description": "COKE DIET",
    "Ext'd Description": "",
    "Size": "2L",
    "Sub Description 2": "SODA",
    "Sub Description 3": "DIET",
    "PriceB": "2.49",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/04900005011.jpg",
    "Qty": 'NA'
  },
  "01480058215": {
    "_id": "5924841b9447efa4c3a85408",
    "Item Lookup Code": "01480058215",
    "Department": "MIXERS & SUPPLIES",
    "Description": "REAL LEMON ",
    "Ext'd Description": "",
    "Size": "2.5oz",
    "Sub Description 2": "COCKTAIL MIXERS",
    "Sub Description 3": "",
    "PriceB": "0.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/01480058215.jpg",
    "Qty": 'NA'
  },
  "07800015345": {
    "_id": "5924841b9447efa4c3a853dc",
    "Item Lookup Code": "07800015345",
    "Department": "MIXERS & SUPPLIES",
    "Description": "CANADA DRY TONIC WATER ",
    "Ext'd Description": "",
    "Size": "1L",
    "Sub Description 2": "MIXERS",
    "Sub Description 3": "",
    "PriceB": "2.29",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/07800015345.jpg",
    "Qty": 'NA'
  },
  "07800001646": {
    "_id": "5924841d9447efa4c3a85636",
    "Item Lookup Code": "07800001646",
    "Department": "MIXERS & SUPPLIES",
    "Description": "SQUIRT",
    "Ext'd Description": "",
    "Size": "2L",
    "Sub Description 2": "SODA",
    "Sub Description 3": "REGULAR",
    "PriceB": "2.49",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/07800001646.jpg",
    "Qty": 'NA'
  },
  "01660433": {
    "_id": "5924841b9447efa4c3a853d4",
    "Item Lookup Code": "01660433",
    "Department": "MIXERS & SUPPLIES",
    "Description": "ROSES SWEETENED LIME JUICE",
    "Ext'd Description": "",
    "Size": "12oz",
    "Sub Description 2": "COCKTAIL MIXERS",
    "Sub Description 3": "",
    "PriceB": "3.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/01660433.jpg",
    "Qty": 'NA'
  },
  "07049135207": {
    "_id": "5924841b9447efa4c3a853c8",
    "Item Lookup Code": "07049135207",
    "Department": "MIXERS & SUPPLIES",
    "Description": "MASTERS OF MIXERS SIMPLE SYRUP",
    "Ext'd Description": "",
    "Size": "375ML",
    "Sub Description 2": "COCKTAIL MIXERS",
    "Sub Description 3": "",
    "PriceB": "3.99",
    "image": "http://res.cloudinary.com/jasons/image/upload/v1488491599/07049135207.jpg",
    "Qty": 'NA'
  }
}

export function sortProductForNoImageToEnd(products) {
  var logoImage = PRODUCT_DEFAULT_IMAGE;
  return products.sort(function(a, b) {
    if (a.image === logoImage) {
      if (b.image === a.image) {
        return 0;
      }
      return 1;
    }

    if (b.image === logoImage) {
      return -1;
    }
  });
}

export function getProductsStore() {
  let productsStore = LocalStorage.get(storeKey);
  return productsStore
    ? productsStore
    : {};
}

export function saveProductsStore(data) {
  LocalStorage.put(storeKey, data)
}

export function saveToStore(key, value) {
  let productsStore = getProductsStore();
  if (!productsStore[key]) {
    productsStore[key] = {
      create_time: (new Date()).getTime()
    }
  }
  productsStore[key].data = value;
  saveProductsStore(productsStore)
}

export function getFromStore(key) {

  let productsStore = getProductsStore();
  if (!productsStore[key])
    return;

  let expireTime = productsStore[key].create_time + productsCacheMaxAge;
  if ((new Date()).getTime() > expireTime)
    return;

  return productsStore[key].data;
}

export function clearProductsStore() {
  LocalStorage.remove(storeKey)
}

export function getSimilarProducts(product) {

  let arr = []
  if (product['Department'] == "RED WINE") {
    arr.push(RECOMMEND['09838260899'])
    arr.push(RECOMMEND['85025100400'])
    arr.push(RECOMMEND['05025592100'])
  } else if (product['Department'] == "WHITE WINE") {
    arr.push(RECOMMEND['09838260899'])
    arr.push(RECOMMEND['85025100400'])
    arr.push(RECOMMEND['05025592100'])
  } else if (product['Department'] == "SPARKLING WINE") {
    arr.push(RECOMMEND['09838260899'])
    arr.push(RECOMMEND['85025100400'])
    arr.push(RECOMMEND['05025592100'])
  } else if (product['Department'] == "ROSE WINE") {
    arr.push(RECOMMEND['09838260899'])
    arr.push(RECOMMEND['85025100400'])
    arr.push(RECOMMEND['05025592100'])
  } else if (product['Department'] == "BEER") {
    arr.push(RECOMMEND['04116541229'])
    arr.push(RECOMMEND['02840002796'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "WHISKEY") {
    arr.push(RECOMMEND['04900005010'])
    arr.push(RECOMMEND['07800015245'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "SCOTCH") {
    arr.push(RECOMMEND['07800015245'])
    arr.push(RECOMMEND['07800014645'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "VODKA") {
    arr.push(RECOMMEND['9311493000509'])
    arr.push(RECOMMEND['61126910802'])
    arr.push(RECOMMEND['01480058200'])
  } else if (product['Category'] == "COGNAC & BRANDY") {
    arr.push(RECOMMEND['04900005010'])
    arr.push(RECOMMEND['04175500106'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "RUM") {
    arr.push(RECOMMEND['9311493000509'])
    arr.push(RECOMMEND['61126910802'])
    arr.push(RECOMMEND['01480058200'])
  } else if (product['Category'] == "VODKA") {
    arr.push(RECOMMEND['04900005010'])
    arr.push(RECOMMEND['04900005011'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "GIN") {
    arr.push(RECOMMEND['01480058215'])
    arr.push(RECOMMEND['01480058200'])
    arr.push(RECOMMEND['07800015345'])
  } else if (product['Category'] == "TEQUILA") {
    arr.push(RECOMMEND['07800001646'])
    arr.push(RECOMMEND['01660433'])
    arr.push(RECOMMEND['350'])
  } else if (product['Category'] == "LIQUER") {
    arr.push(RECOMMEND['07049135207'])
    arr.push(RECOMMEND['01480058215'])
    arr.push(RECOMMEND['350'])
  } else {
    arr.push(RECOMMEND['04116541229'])
    arr.push(RECOMMEND['04900005010'])
    arr.push(RECOMMEND['350'])
  }
  return arr
}



// WEBPACK FOOTER //
// ./src/utils/productHelpers.js